<template>
  <div :class="containerClass"><img :src="src" /></div>
</template>

<script>
export default {
  props: {
    containerClass: String,
    src: String,
  },
}
</script>
